import { Head, CleanContent } from './ui';
import showcaseImage from '../../../../assets/images/Landing_Page/showcase-img.png';

export default function ShowcasePreview() {
  return (
    <CleanContent><section className="bg-soft py-5">
        <div className="container">
          <Head eyebrow="Standard of Excellence" title="Anatomy of an Accredited Showcase"
            text="See how leading national enterprises present their institutional credentials to commercial buyers and verified partners" />
          <div className="bg-white border border-line rounded-3 overflow-hidden mx-auto" style={{ maxWidth: 820 }}>
            <div className="shop-banner position-relative">
              <img className="shop-banner-image" src={showcaseImage} alt="Coffee shop interior" />
              <span className="badge badge-star position-absolute top-0 start-0 m-3">SELECTEZI <i className="bi bi-star-fill" /> 7 | LEADING REGIONAL</span>
            </div>
            <div className="p-3 p-md-4">
              <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
                <div className="shop-logo rounded-3 d-flex align-items-center justify-content-center">UH</div>
                <div className="flex-grow-1">
                  <div className="h-md fs-5">Urban Heritage Coffee Co</div>
                  <div className="p-sm">Direct Trade Single Origin Beans & Commercial Equipment Leasing</div>
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-blue btn-sm">Connect & Message</button>
                  <button className="btn btn-outline-secondary btn-sm">Save</button>
                </div>
              </div>
              <div className="row g-2 text-center mb-3">
                {[["1,284", "Qualified Users"], ["4.6 / 5.0", "127 Evaluations"], ["2,430", "Followers"], ["94%", "Response (<15m)"]].map(([a, b]) => (
                  <div className="col-6 col-md-3" key={b}>
                    <div className="bg-soft rounded-2 p-2"><div className="fw-bold">{a}</div><div className="p-sm">{b}</div></div>
                  </div>
                ))}
              </div>
              <div className="d-flex flex-wrap gap-2">
                {["Business Information Verified", "Active Community Member", "Physical Commercial Headquarters", "Quality Assurance Audited", "Active Verified Today"].map((b) => (
                  <span className="badge tag-green" key={b}><i className="bi bi-check-circle me-1" />{b}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section></CleanContent>
  );
}
